export const consolePanel = {
  // 获取顶部导航栏-GET
  getNavTopMenu: `/cms/v1/console_menu`,
  // 获取region-GET
  // getRegion: `pco/v1/region/list`,
  // getRegion: `/resource/pco/v1/resource/user_azone/user`,
  getRegion: `/aidp/apis/v1/region`,
  // 获取账户余额-GET
  getAccountRemainder: `/expense?Action=walletSummary`,
  // 获取消息条数-GET
  getMessageCount: `/uco/v1/message/count`,
  // 获取未读消息
  getUnreadMessage: `/uco/v1/message/list?readState=0&page=1&size=10`,
  // 获取待处理工单
  getPendingOrder: `/workorder/wo?Action=ListWorkOrders&status=minedeal&page=1&size=10&startTime=&endTime=`,
  // 登出-DELETE
  logout: `/pco/user/v1/logout`,
  // 子用户登出-DELETE
  childLogout: `/pco/user/v1/child/logout`,
  // 获取默认导航-GET
  getDefaultMenu: `/cms/v1/user/console`,
  // 添加自定义导航-POST
  addCustomMenu: `/cms/v1/user/console`,
};
